import React, { useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Autocomplete from "@material-ui/lab/Autocomplete";
import TextField from "@material-ui/core/TextField";
import { initialParams } from "utils/utils";
import { transcriptionLanguages } from "utils/data";

const useStyles = makeStyles(() => ({
  inputRoot: {
    "& label.Mui-focused": {
      color: "#507b82",
    },
    "& .MuiInput-underline:after": {
      borderBottomColor: "#507b82",
    },
    "& .MuiInputLabel-shrink": {
      fontSize: "1.25rem",
    },
    "& .MuiInputBase-input": {
      backgroundColor: "unset",
    },
    "& .MuiChip-root": {
      backgroundColor: "#E7CFF2",
    },
  },
}));

const PickLang = ({ languages, submitLanguages, initialLanguages }) => {
  const classes = useStyles();

  const [items, setItems] = useState(initialParams(initialLanguages));

  if (!Array.isArray(languages) || languages.length < 2) {
    return null;
  }

  const handleChange = (_, values) => {
    setItems(values);
    submitLanguages(values);
  };

  return (
    <Autocomplete
      multiple
      id="lang-tags"
      options={languages}
      getOptionLabel={(item) =>
        transcriptionLanguages[item] ? transcriptionLanguages[item] : item
      }
      onChange={handleChange}
      value={items}
      renderInput={(params) => (
        <TextField
          {...params}
          variant="standard"
          label="Filter by language"
          className={classes.inputRoot}
        />
      )}
    />
  );
};

export default PickLang;
